/** @jsx jsx */
import { jsx, Flex, Box, Styled } from "theme-ui";
import { useState } from "react";

import MinusIcon from "../images/icons/minus.inline.svg"
import PlusIcon from "../images/icons/plus.inline.svg"

const QuestionAnswer = ({ active = false, questionAnswer: { question, answer }}) => {
  const [isActive, setActive] = useState(active)
  const Icon = isActive ? MinusIcon : PlusIcon
  
  return (
   <div sx={{
     overflow: 'hidden',
     p: 3
   }}>
     <Flex
       onClick={ () => {
         setActive(!isActive)
       }}
       sx={{
         bg: isActive ? 'white' : 'gray.3',
         px: [3, 4],
         py: 3,
         mb: 3,
         cursor: 'pointer',
         alignItems: 'center'
       }}
       as="header">
       <Box>
         <Icon sx={{ width: '25px' }} />
       </Box>
       <Box
         sx={{
           ml: 4
         }}>
        <Styled.h5
          sx={{
            color: 'primary',
            m: 0 
          }}>{ question }</Styled.h5>
       </Box>
     </Flex>
     <div
       sx={{
         px: [4, '42px'],
         mx: [0, '42px'],
         borderLeft: theme => `4px solid ${theme.colors.primary}`,
         overflow: 'hidden',
         height: isActive ? 'auto' : 0
       }}
       dangerouslySetInnerHTML={ {__html: answer} } />
   </div> 
  )
}

export default QuestionAnswer 